// extracted by mini-css-extract-plugin
module.exports = {"shock":"jobBoost_shock__GZtYK","timer":"jobBoost_timer__JQ_Nn"};